import { ArrowLeft, ArrowRight } from "lucide-react";
import { useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { BrandMark } from "../../components/BrandMark";
import { authClient } from "../../lib/auth-client";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    const form = new FormData(event.currentTarget);
    if (token) {
      const password = String(form.get("password"));
      const confirmation = String(form.get("confirmation"));
      if (password !== confirmation) {
        setError("Die Passwörter stimmen nicht überein.");
        return;
      }
      const result = await authClient.resetPassword({
        newPassword: password,
        token,
      });
      if (result.error) {
        setError("Der Link ist ungültig oder abgelaufen.");
        return;
      }
      navigate("/admin/login", { replace: true });
      return;
    }
    const result = await authClient.requestPasswordReset({
      email: String(form.get("email")),
      redirectTo: `${window.location.origin}/admin/reset-password`,
    });
    if (!result.error) setSent(true);
  };

  return (
    <div className="auth-simple">
      <BrandMark inverse />
      <main id="main" className="auth-card">
        <Link to="/admin/login">
          <ArrowLeft size={16} /> Zur Anmeldung
        </Link>
        <h1>{token ? "Neues Passwort." : "Passwort vergessen?"}</h1>
        {sent ? (
          <p>
            Wenn ein Konto zu dieser Adresse existiert, ist der sichere Link
            unterwegs.
          </p>
        ) : (
          <form onSubmit={submit}>
            {token ? (
              <>
                <label>
                  <span>Neues Passwort</span>
                  <input
                    name="password"
                    type="password"
                    minLength={12}
                    required
                  />
                </label>
                <label>
                  <span>Wiederholen</span>
                  <input
                    name="confirmation"
                    type="password"
                    minLength={12}
                    required
                  />
                </label>
              </>
            ) : (
              <label>
                <span>E-Mail</span>
                <input name="email" type="email" required autoFocus />
              </label>
            )}
            {error && (
              <p className="form-error" role="alert">
                {error}
              </p>
            )}
            <button type="submit">
              {token ? "Passwort speichern" : "Sicheren Link senden"}{" "}
              <ArrowRight size={17} />
            </button>
          </form>
        )}
      </main>
    </div>
  );
}
